<template>
    <div>
        <header class="header">
            <div class="header-content">
                <img src="@/assets/images/logo.svg" class="logo" alt="" />
                <h1 class="header-title">Chicchi Nails</h1>
            </div>
        </header>
        <div class="container">
            <!-- 使用Element UI轮播图组件 -->
            <el-carousel :height="carouselHeight">
                <el-carousel-item v-for="(item, index) in storeInfo.storeImages" :key="index">
                    <img class="carousel-image" :src="item.url" alt="美甲展示图" />
                </el-carousel-item>
            </el-carousel>

            <!-- 门店信息 -->
            <div class="store-info mar-l-r">
                <div class="store-item store-item-address" @click="navigateToStore">
                    <img class="store-icon" src="@/assets/images/address.png" alt="" />
                    <span>{{ storeInfo.name }}, {{ storeInfo.address }}</span>
                </div>
                <div class="store-item mt-10">
                    <img class="store-icon" src="@/assets/images/time.png" alt="" />
                    <span v-if="todayHours.isOpen"> {{ $it.open_today }}：<span v-if="todayHours.day">{{ todayHours.day }} , </span>{{ todayHours.startTime }} - {{ todayHours.endTime }}</span>
                    <span v-else> {{ $it.open_today }}：{{ $it.close_door }}</span>
                </div>
            </div>

            <div class="main-content mar-l-r">
                <h2 class="section-title">{{ $it.select_service }}</h2>

                <!-- 服务选择区域：左侧类别，右侧内容 -->
                <div class="service-selection-container">
                    <!-- 移动端水平滚动服务类别导航 -->
                    <div class="mobile-service-categories" v-if="screenWidth <= 768">
                        <div class="mobile-categories-scroll">
                            <div v-for="(category, key) in serviceData" :key="key" class="mobile-category" :class="{ active: activeCategory === key }" @click="setActiveCategory(key)">
                                <span class="category-name">{{ getCategoryName(key) }}</span>
                                <span class="category-number">({{ category.count }})</span>
                                <span class="check-icon-top" v-if="hasCategorySelected(key)" :class="{ visibleAct: activeCategory === key }">✓</span>
                            </div>
                        </div>
                    </div>

                    <!-- 左侧服务类别导航（桌面端） -->
                    <div class="service-categories" v-if="screenWidth > 768">
                        <div v-for="(category, key) in serviceData" :key="key" class="category" :class="{ active: activeCategory === key }" @click="setActiveCategory(key)">
                            <div class="category-left">
                                <span class="check-icon" :class="{ visible: hasCategorySelected(key) }">✓</span>
                                <span class="category-name">{{ getCategoryName(key) }}</span>
                            </div>
                            <span class="category-count">({{ category.count }})</span>
                        </div>
                    </div>

                    <!-- 右侧服务项目列表 -->
                    <div class="service-list-container" :class="{ 'full-width': screenWidth <= 768 }">
                        <div class="service-list">
                            <div v-for="(service, index) in filteredServices" :key="index" class="service-item" :data-category="service.category">
                                <div class="service-info">
                                    <h3 class="service-name">{{ service.name }}</h3>
                                    <p class="service-duration">{{ service.duration }} minuti</p>
                                    <p class="service-description">{{ service.description }}</p>
                                </div>
                                <div class="service-price-area">
                                    <p class="current-price">{{ formatPrice(service.price) }}</p>
                                    <span v-if="service.selected" class="selected-label" @click="toggleServiceSelection(service)">{{ $it.selected }}</span>
                                    <span v-else class="select-button" @click="toggleServiceSelection(service)">{{ $it.unselected }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 地图区域 -->
            <!-- <div class="map-section">
                <div class="map-header">
                    <h3 class="section-title">{{ $it.store_address }}</h3>
                    <div class="navigation-button" @click="navigateToStore">
                        {{ $it.navigate }}
                    </div>
                </div>
                <div class="map-container">
                    <gmap-map :center="center" :zoom="15" map-type-id="roadmap" style="width: 100%; height: 100%">
                        <gmap-marker v-for="(marker, index) in markers" :key="index" :position="marker.position" :clickable="true" :draggable="false" @click="center = marker.position"> </gmap-marker>
                    </gmap-map>
                </div>
                <div class="store-description">
                    <h3>{{ storeInfo.name }}</h3>
                    <p>{{ storeInfo.address }}</p>
                </div>
                <div class="store-description">
                    <p>{{ storeInfo.description }}</p>
                </div>
            </div> -->

            <!-- 营业时间表 -->
            <div class="business-hours-table mar-l-r" v-if="businessHours && businessHours.length > 0">
                <div class="day-row" v-for="(hours, day) in businessHours" :key="day">
                    <div class="day-indicator" :class="{ closed: !hours || !hours.isOpen }"></div>
                    <div class="day-name">{{ hours && hours.day }}</div>
                    <div class="day-hours" v-if="hours && hours.isOpen">{{ hours.startTime }} - {{ hours.endTime }}</div>
                    <div class="day-hours" v-else>chiudere la porta</div>
                </div>
            </div>
            <div class="privacy-policy-link mar-l-r" @click="goToPrivacy">
                {{ $it.privacy_policy }}
            </div>
        </div>

        <!-- 购物车弹窗遮罩 -->
        <div v-if="showCartPopup" class="cart-mask" @click="showCartPopup = false"></div>

        <!-- 购物车弹窗内容 -->
        <transition name="slide-up">
            <div v-if="showCartPopup" class="cart-popup">
                <div class="cart-header">
                    <span class="cart-title">{{ $it.selected_service }} ({{ selectedServicesCount }})</span>
                    <i class="el-icon-arrow-down close-icon" @click="showCartPopup = false"></i>
                </div>
                <div class="cart-list">
                    <div v-for="(service, index) in selectedServices" :key="index" class="service-item">
                        <div class="service-info">
                            <h3 class="service-name">{{ service.name }}</h3>
                            <p class="service-duration">{{ service.duration }} minuti</p>
                            <p class="service-description" v-if="service.description">{{ service.description }}</p>
                        </div>
                        <div class="service-price-area">
                            <p class="current-price">{{ formatPrice(service.price) }}</p>
                            <i class="el-icon-delete delete-icon" @click="toggleServiceSelection(service)"></i>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <!-- 底部结账栏 -->
        <div class="booking-bar" @click="toggleCartPopup">
            <div class="booking-info">
                <span class="service-count"
                    >{{ $it.selected_service }}： <span>{{ selectedServicesCount }}</span>
                    <i :class="showCartPopup ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="margin-left: 5px"></i>
                </span>
                <span
                    ><span style="font-size: 18px; font-weight: bold">{{ formatPrice(totalPrice) }}</span>
                </span>
            </div>
            <!-- <button class="booking-button" @click="goToBooking"></button> -->
            <div class="booking-button" @click="goToBooking">{{ $it.go_to_booking }}</div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import { formatPrice } from '@/utils/formatters'
export default {
    name: 'AppointmentView',
    data() {
        return {
            // 轮播图数据
            carouselImages: ['https://images.unsplash.com/photo-1519014816548-bf5fe059798b?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80', 'https://images.unsplash.com/photo-1522337660859-02fbefca4702?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'],

            // 地图相关数据
            center: { lat: 45.468588, lng: 9.190476 },
            markers: [
                {
                    position: { lat: 45.468588, lng: 9.190476 },
                    infoText: 'Chicchi Nails 米兰店',
                    address: 'Via Mercato, 10, 20121 米兰 MI, 意大利',
                    phone: '+39 02 1234 5678'
                }
            ],

            // 服务类别和项目数据
            activeCategory: 'promotion',
            serviceData: {},

            // 服务项目列表
            services: [],

            // 营业时间
            businessHours: [],
            storeInfo: {
                todayBusinessHours: {}
            },
            //门店ID
            servicesID: 50,
            carouselHeight: '480px',
            screenWidth: 0,
            showCartPopup: false,
            // 门店加载序号：切换门店时自增，用来丢弃上一家门店的迟到响应
            loadSeq: 0
        }
    },
    computed: {
        // 今日营业时间：部分门店（如 Apple Review Store）接口不返回 todayBusinessHours，
        // 只返回 businessHours 字符串（如 "10:00-19:00"），这里统一兜底，避免模板读 undefined.isOpen 报错
        todayHours() {
            const info = this.storeInfo || {}
            if (info.todayBusinessHours) {
                return info.todayBusinessHours
            }
            const raw = typeof info.businessHours === 'string' ? info.businessHours.trim() : ''
            const matched = raw.match(/^(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})$/)
            if (matched) {
                return { isOpen: true, day: '', startTime: matched[1], endTime: matched[2] }
            }
            return {}
        },
        // 根据当前选择的类别过滤服务列表
        filteredServices() {
            return this.services.filter(service => service.category === this.activeCategory)
        },
        // 已选服务数量
        selectedServicesCount() {
            return this.services.filter(service => service.selected).length
        },

        // 总价
        totalPrice() {
            let total = 0
            this.services.forEach(service => {
                if (service.selected) {
                    // 使用parseFloat将价格转换为数字，而不是字符串
                    const price = parseFloat(service.price)
                    total += price
                }
            })
            // 返回时格式化为两位小数
            return total.toFixed(2)
        },
        // 已选服务列表
        selectedServices() {
            return this.services.filter(service => service.selected)
        }
    },
    watch: {
        // 只改 hash 里的 ?id=（如 #/home?id=55 → #/home?id=63）不会重建组件，
        // created 不会再执行，页面会继续显示上一家门店的数据（URL 是 A、内容是 B）。
        // 这里在 id 变化时重新按新门店拉数据。
        '$route.query.id'(newId) {
            if (String(newId || '') === String(this.servicesID || '')) return
            this.loadStore()
        }
    },
    created() {
        this.loadStore()
    },
    mounted() {
        this.screenWidth = window.innerWidth
        this.setSize()
        window.onresize = () => {
            this.screenWidth = window.innerWidth
            this.setSize()
        }
    },
    methods: {
        formatPrice,
        // 按 URL 上的门店 id 初始化/切换门店：清空上一家门店的残留数据后再拉取
        loadStore() {
            const servicesID = this.$route.query.id
            this.servicesID = servicesID || 50
            this.loadSeq += 1
            this.storeInfo = { todayBusinessHours: {} }
            this.services = []
            this.serviceData = {}
            this.activeCategory = 'promotion'
            this.businessHours = []
            this.showCartPopup = false
            this.fetchServices()
            this.fetchServicesList()
            this.fetchBusinessHours()
        },
        // 获取当前屏幕尺寸
        setSize() {
            if (this.screenWidth < 768) {
                this.carouselHeight = '280px'
            } else {
                this.carouselHeight = '480px'
            }
        },
        goToPrivacy() {
            this.$router.push('/privacy')
        },
        // 获取门店信息
        fetchServices() {
            const seq = this.loadSeq
            axios
                .get(`${config.baseURL}api/stores/open/${this.servicesID}`, {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        languageCodes: 'it-IT'
                    }
                })
                .then(response => {
                    // 门店已切换，丢弃上一家门店的迟到响应
                    if (seq !== this.loadSeq) return
                    if (response.data.code === 200) {
                        const data = response.data.data || {}
                        // 兼容接口不返回 todayBusinessHours / storeImages 的门店，保证模板读到的字段结构稳定
                        this.storeInfo = {
                            ...data,
                            todayBusinessHours: data.todayBusinessHours || null,
                            storeImages: data.storeImages || []
                        }
                        this.center = { lat: data.latitude, lng: data.longitude }
                        this.markers = [
                            {
                                position: { lat: data.latitude, lng: data.longitude },
                                infoText: data.name,
                                address: data.address,
                                phone: data.phone
                            }
                        ]
                    } else {
                        this.$message.error('获取门店信息失败')
                    }
                })
                .catch(error => {
                    console.error('Error fetching services:', error)
                })
        },
        //获取服务列表
        fetchServicesList() {
            const seq = this.loadSeq
            axios
                .get(`${config.baseURL}api/serviceItem/open`, {
                    params: {
                        keyword: '',
                        departmentId: this.servicesID
                    },
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        languageCodes: 'it-IT'
                    }
                })
                .then(response => {
                    if (seq !== this.loadSeq) return
                    if (response.data && response.data.code === 200) {
                        let res = response.data.data || {}
                        Object.entries(res).forEach(([categoryName, services]) => {
                            this.serviceData[categoryName] = {
                                count: services.length,
                                name: categoryName
                            }
                            services.forEach(service => {
                                this.services.push({
                                    name: service.name,
                                    price: service.price,
                                    description: service.description,
                                    duration: service.duration,
                                    category: categoryName,
                                    selected: false,
                                    id: service.id
                                })
                            })
                        })
                        this.activeCategory = Object.keys(this.serviceData)[0]
                        // this.services = response.data.data || [];
                    } else {
                        console.error('获取服务列表失败:', response)
                    }
                })
                .catch(error => {
                    console.error('获取服务列表错误:', error)
                })
        },
        // 获取门店营业时间
        fetchBusinessHours() {
            const seq = this.loadSeq
            axios
                .get(`${config.baseURL}api/businessHours/open`, {
                    params: {
                        departmentId: this.servicesID
                    },
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        languageCodes: 'it-IT'
                    }
                })
                .then(response => {
                    if (seq !== this.loadSeq) return
                    if (response.data && response.data.code === 200) {
                        this.businessHours = response.data.records || []
                    } else {
                        console.error('获取营业时间失败:', response)
                    }
                })
                .catch(error => {
                    console.error('获取营业时间错误:', error)
                })
        },
        // 设置当前活动类别
        setActiveCategory(category) {
            this.activeCategory = category
        },

        // 获取类别名称
        getCategoryName(key) {
            console.log(key)

            return this.serviceData[key].name
        },

        // 检查类别是否有选中的服务
        hasCategorySelected(category) {
            return this.services.some(service => service.category === category && service.selected)
        },

        // 切换服务选择状态
        toggleServiceSelection(service) {
            service.selected = !service.selected
            // 如果取消选择后没有已选服务，关闭弹窗
            if (this.selectedServicesCount === 0) {
                this.showCartPopup = false
            }
        },

        // 切换购物车弹窗显示
        toggleCartPopup() {
            if (this.selectedServicesCount > 0) {
                this.showCartPopup = !this.showCartPopup
            }
        },

        // 返回上一页
        goBack() {
            window.history.back()
        },

        // 去预约
        goToBooking() {
            const selectedServices = this.services.filter(service => service.selected)

            // 检查是否有选中的服务
            if (selectedServices.length === 0) {
                this.$message({
                    message: this.$it.Select_at_least_one_service,
                    type: 'warning'
                })
                return
            }

            // 收集表单数据
            const formData = {
                services: selectedServices.map(service => ({
                    name: service.name,
                    price: service.price,
                    description: service.description,
                    category: service.category,
                    duration: service.duration,
                    serviceId: service.id,
                    departmentId: this.servicesID
                }))
            }
            // 收集选中的服务数据
            console.log(formData)

            // 将服务数据传递给预约详情页面
            this.$router.push({
                path: '/detail',
                query: {
                    services: encodeURIComponent(JSON.stringify(formData.services))
                }
            })
        },
        navigateToStore() {
            console.log(this.center)

            // 店铺坐标
            const latitude = this.center.lat
            const longitude = this.center.lng
            const storeName = encodeURIComponent('Chicchi Nails 米兰店')
            window.open(`https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}&destination_place_id=${storeName}&travelmode=driving`, '_blank')
        }
    }
}
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

body {
    background-color: #f8f8f8;
    color: #333;
    line-height: 1.6;
}

.container {
    max-width: 1000px;
    margin: 0 auto;
    padding-bottom: 120px;
    /* padding-top: 10px; */
}

.header {
    background-color: #fff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    padding: 10px 0;
    position: sticky;
    top: 0;
    z-index: 100;
}

.header-content {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    padding: 0 10px;
}

.logo {
    height: 40px;
    margin-right: 15px;
}

.header-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
}

.back-button {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    font-size: 18px;
    color: #333;
    cursor: pointer;
}

.main-content {
    padding: 15px;
    background-color: #fff;
    margin-top: 10px;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.section-title {
    font-size: 18px;
    font-weight: 500;
    color: #333;
}

/* 服务选择区域布局 */
.service-selection-container {
    display: flex;
    margin-top: 15px;
    flex-direction: column;
}

@media (min-width: 769px) {
    .service-selection-container {
        flex-direction: row;
    }
}

/* 移动端水平滚动服务类别导航 */
.mobile-service-categories {
    width: 100%;
    overflow-x: auto;
    margin-bottom: 15px;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Firefox */
}

.mobile-service-categories::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Edge */
}

.mobile-categories-scroll {
    display: flex;
    flex-wrap: nowrap;
    padding-bottom: 5px;
}

.mobile-category {
    padding: 8px 15px;
    background-color: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    /* transition: all 0.3s; */
    margin-right: 10px;
    flex-shrink: 0;
    border-radius: 20px; /* 椭圆形 */
    white-space: nowrap;
    border: 1px solid #eee;
}

.mobile-category.active {
    background-color: #ff6b81;
    color: white;
}

.mobile-category .category-name {
    margin-right: 4px;
}

.mobile-category .category-number {
    font-size: 12px;
    margin-left: 2px;
}

.mobile-category .category-count {
    font-size: 12px;
    color: white;
    margin-left: 4px;
}

/* 左侧服务类别导航 */
.service-categories {
    width: 30%;
    flex-shrink: 0;
    margin-right: 15px;
    display: flex;
    flex-direction: column;
}

.category {
    padding: 15px;
    background-color: #f5f5f5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s;
    border-left: 3px solid transparent;
}

.category.active {
    background-color: #fff;
    border-left: 3px solid #ff6b81;
}

.category-left {
    display: flex;
    align-items: center;
    /* gap: 8px; */
}

.check-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    color: #ff6b81;
    font-size: 12px;
    opacity: 0;
    transition: opacity 0.3s;
}

.check-icon.visible {
    opacity: 1;
}
.check-icon-top {
    width: 16px;
    height: 16px;
    color: #ff6b81;
    font-size: 12px;
    margin-left: 10px;
    margin-bottom: 4px;
}
.check-icon-top.visibleAct {
    color: #fff !important;
}
.category-name {
    font-size: 14px;
    word-wrap: break-word;
    word-break: break-all;
}

.category-count {
    font-size: 12px;
    color: #999;
}

/* 右侧服务列表 */
.service-list-container {
    flex: 1;
    background-color: #fff;
    padding: 15px;
}

.service-list-container.full-width {
    width: 100%;
}

.service-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.service-item {
    display: flex;
    justify-content: space-between;
    padding: 0;
    border: none;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 20px;
}

.service-item:hover {
    box-shadow: none;
}

.service-info {
    flex: 1;
}

.service-name {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 5px;
}

.service-duration {
    font-size: 13px;
    color: #666;
    margin-bottom: 5px;
}

.service-description {
    font-size: 13px;
    color: #999;
}

.service-price-area {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    min-width: 100px;
}

.current-price {
    font-size: 18px;
    font-weight: 500;
    color: #333;
    margin-bottom: 5px;
}

.original-price {
    font-size: 13px;
    color: #999;
    text-decoration: line-through;
    margin-bottom: 10px;
}

.select-button {
    padding: 3px 15px;
    background-color: #fff;
    color: #ff6b81;
    border: 1px solid #ff6b81;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 14px;
}

.select-button:hover {
    background-color: #ff6b81;
    color: #fff;
}

.selected-label {
    padding: 3px 15px;
    background-color: #f0f8ff;
    color: #008800;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
}

/* 轮播图样式 */
.el-carousel__item {
    height: 280px;
}
@media (min-width: 768px) {
    .el-carousel__item {
        height: 480px;
    }
}

.el-carousel__item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* 地图区域 */
.map-section {
    padding: 15px;
    background-color: #fff;
    margin-top: 10px;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.map-container {
    height: 200px;
    margin-bottom: 15px;
    border-radius: 8px;
    overflow: hidden;
}

.store-description {
    margin-bottom: 15px;
}

.store-description h3 {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 5px;
}

.store-description p {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
}

/* 营业时间表 */
.business-hours-table {
    padding: 15px;
    background-color: #fff;
    margin-top: 10px;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.day-row {
    display: flex;
    padding: 10px 0;
    /* border-bottom: 1px solid #eee; */
}

.day-row:last-child {
    border-bottom: none;
}

.day-indicator {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #52c41a;
    margin-right: 10px;
    margin-top: 5px;
}

.day-name {
    font-size: 14px;
    width: 70px;
}

.day-hours {
    font-size: 14px;
    color: #666;
}

/* 底部结账栏 */
.booking-bar {
    position: fixed;
    bottom: 0;
    left: 50%;
    max-width: 1000px;
    width: 100%;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    padding: 10px 15px;
    padding-bottom: 30px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    z-index: 100;
    transform: translateX(-50%);
    cursor: pointer;
}
/* .booking-bar-box{
  max-width: 1000px;

  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
} */

.booking-info {
    display: flex;
    flex-direction: column;
}

.service-count {
    font-size: 14px;
    color: #666;
}

.total-price {
    font-size: 18px;
    font-weight: 500;
    color: #ff4d4f;
}

.booking-button {
    padding: 8px 20px;
    background-color: #ff6b81;
    color: #fff;
    border: none;
    border-radius: 20px;
    font-size: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.store-item {
    display: flex;
    align-items: center;
}

.store-item.mt-10 {
    margin-top: 10px;
}

.store-icon {
    width: 18px;
    height: 18px;
    margin-right: 10px;
}

.store-info {
    padding: 15px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    font-size: 14px;
    color: #222;
    margin-top: 10px;
}

/* 地图信息窗口样式 */
.info-window {
    padding: 5px;
    min-width: 200px;
}

.info-window h4 {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 5px;
    color: #ff6b81;
}

.info-window p {
    font-size: 13px;
    color: #666;
    margin-bottom: 3px;
}
.map-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
}
.navigation-button {
    cursor: pointer;
    color: #ff6b81;
}

.privacy-policy-link {
    cursor: pointer;
    color: #ff6b81;
    margin-top: 10px;
    text-decoration: underline;
}

.closed {
    background-color: #999;
}
.store-item-address {
    cursor: pointer;
}

/* 购物车弹窗样式 */
.cart-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 90;
}

.cart-popup {
    position: fixed;
    bottom: 82px; /* 调整回合适的距离 */
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 1000px;
    background-color: #fff;
    border-radius: 16px 16px 0 0;
    z-index: 95;
    max-height: 70vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 -4px 15px rgba(0, 0, 0, 0.15);
}

.cart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    border-bottom: 1px solid #f0f0f0;
}

.cart-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
}

.close-icon {
    font-size: 20px;
    color: #999;
    cursor: pointer;
}

.cart-list {
    overflow-y: auto;
    padding: 0 20px 20px; /* 增加底部内边距 */
}

.cart-list .service-item {
    padding: 15px 0;
}

.delete-icon {
    font-size: 22px;
    color: #ff6b81;
    cursor: pointer;
    margin-top: 5px;
}

.delete-icon:hover {
    opacity: 0.8;
}

/* 动画效果 */
.slide-up-enter-active,
.slide-up-leave-active {
    transition: all 0.3s ease;
}

.slide-up-enter,
.slide-up-leave-to {
    transform: translate(-50%, 100%);
    opacity: 0;
}

@media (max-width: 768px) {
    .cart-popup {
        bottom: 82px;
    }
    .mar-l-r {
        margin-left: 8px;
        margin-right: 8px;
    }
}
</style>
